module.exports = __webpack_public_path__ + "static/media/NEMA6FOTO.12580d60.jpg";